import { createSelector } from 'reselect';
import { type AppStore } from '../store';

/**
 * Base selector: Get named beneficiaries from store
 */
const selectNamedBeneficiaries = (state: AppStore) => state.namedBeneficiaries;

/**
 * Memoized selector: Calculate total percentage of all named beneficiaries
 *
 * @returns number | undefined - Sum of all beneficiary percentages, undefined if no beneficiaries
 */
export const selectNamedBeneficiariesTotalPercentage = createSelector(
  [selectNamedBeneficiaries],
  (namedBeneficiaries) => {
    if (!namedBeneficiaries || namedBeneficiaries.length === 0) {
      return undefined;
    }

    return namedBeneficiaries.reduce(
      (sum, beneficiary) => sum + (beneficiary.percentage ?? 0),
      0
    );
  }
);

/**
 * Hook: Get total percentage of named beneficiaries
 * Usage: useAppStore(selectNamedBeneficiariesTotalPercentage)
 */
